import { Component } from '@angular/core';

/**
 * @deprecated.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Component({
    selector: 'ap-grid-col',
    templateUrl: './col.component.html'
})
export class ApColComponent {}
